import { render, staticRenderFns } from "./no-search-result.vue?vue&type=template&id=201f9a16&scoped=true&"
import script from "./no-search-result.vue?vue&type=script&lang=js&"
export * from "./no-search-result.vue?vue&type=script&lang=js&"
import style0 from "./no-search-result.vue?vue&type=style&index=0&id=201f9a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f9a16",
  null
  
)

export default component.exports